import axiosInstance from './axiosInstance';

export interface Site {
  id: number;
  name: string;
  closed: boolean;
}

export interface CreateSiteRequest {
  name: string;
  closed?: boolean;
}

export interface UpdateSiteRequest {
  name: string;
  closed: boolean;
}

class SitesApi {
  async getAllSites(): Promise<Site[]> {
    try {
      const response = await axiosInstance.get<Site[]>('/Sites');
      return response.data;
    } catch (error) {
      console.error('Error fetching sites:', error);
      throw error;
    }
  }

  async getSite(id: number): Promise<Site> {
    try {
      const response = await axiosInstance.get<Site>(`/Sites/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching site:', error);
      throw error;
    }
  }

  async createSite(siteData: CreateSiteRequest): Promise<Site> {
    try {
      const response = await axiosInstance.post<Site>('/Sites', siteData);
      return response.data;
    } catch (error) {
      console.error('Error creating site:', error);
      throw error;
    }
  }

  async updateSite(id: number, siteData: UpdateSiteRequest): Promise<void> {
    try {
      await axiosInstance.put(`/Sites/${id}`, siteData);
    } catch (error) {
      console.error('Error updating site:', error);
      throw error;
    }
  }

  async deleteSite(id: number): Promise<void> {
    try {
      await axiosInstance.delete(`/Sites/${id}`);
    } catch (error) {
      console.error('Error deleting site:', error);
      throw error;
    }
  }
}

export const sitesApi = new SitesApi();
